import { render, staticRenderFns } from "./layer-release-shops.vue?vue&type=template&id=4d254740&scoped=true&"
import script from "./layer-release-shops.vue?vue&type=script&lang=js&"
export * from "./layer-release-shops.vue?vue&type=script&lang=js&"
import style0 from "./layer-release-shops.vue?vue&type=style&index=0&id=4d254740&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d254740",
  null
  
)

export default component.exports